import React, { useEffect } from "react";
import { useState } from "react";
import { Dialog } from "../dialog";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import { ROUTES } from "../../../../configs/routes";
import { SHOW_TIMEOUT_DIALOG } from "../../../../constants/storage";

interface Props {
  isTimeOutDialogOpen: boolean;
  testId?: string;
}
export const IdleTimeoutDialog: React.FC<Props> = (props) => {
  const { isTimeOutDialogOpen, testId } = props;
  const { t } = useTranslation();
  const [showTimeoutDialog, setSshowTimeoutDialog] = useState<boolean>(false);
  const isLoggedIn = useSelector<ApplicationState, boolean>(
    (state) => state.auth.isLoggedIn
  );

  useEffect(() => {
    if (isTimeOutDialogOpen && !isLoggedIn) {
      setSshowTimeoutDialog(true);
      window.history.replaceState(null, "", ROUTES.ROOT);
    }
  }, [isTimeOutDialogOpen, isLoggedIn]);

  return (
    <Dialog
      id="timeout-dialog"
      testId={testId}
      show={showTimeoutDialog}
      title={t("PRIVACY_SESSION_TIMEOUT_TITLE")}
      body={`${t("PRIVACY_SESSION_TIMEOUT_BODY1")} ${"\n"} ${t(
        "PRIVACY_SESSION_TIMEOUT_BODY2"
      )} `}
      handleClose={() => {
        setSshowTimeoutDialog(false);
        localStorage.removeItem(SHOW_TIMEOUT_DIALOG);
      }}
      buttonTitle={t("PRIVACY_DIALOG_OK")}
      isIdleDialog={true}
    />
  );
};
